import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { VatResource } from "@exonn/js-sdk";

export const module: ModuleOptions<VatResource> = {
  resource: ResourceEnum.Vat,
  bigIcon: <i className="icon-20-tax" />,
  smallIcon: <i className="icon-15-tax" />,
};
